import { render, staticRenderFns } from "./EmbedVideo.vue?vue&type=template&id=469efb08&scoped=true"
import script from "./EmbedVideo.vue?vue&type=script&lang=js"
export * from "./EmbedVideo.vue?vue&type=script&lang=js"
import style0 from "./EmbedVideo.vue?vue&type=style&index=0&id=469efb08&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "469efb08",
  null
  
)

export default component.exports